<template>
    <div class="content_box">
        <v-snackbar
            v-model="tokensApiFailed"
            top center :timeout=10000
            :color="errorColor"> 
            <v-icon dark>warning</v-icon> &nbsp;&nbsp;
            <span>Api failed</span>
            <v-btn :color="errorColor" flat @click="tokensApiFailed = null; tokensApiFailed = false;" class="black--text snackbar-button">Close</v-btn>
        </v-snackbar>

        <v-card flat class="settings_panel_card">
            <v-toolbar flat dense class="settings_toolbar">
                <v-toolbar-title class="settings_panel_heading">Access Tokens</v-toolbar-title>
                <v-spacer></v-spacer>
                <textarea id="unmasked_token_data" :value="tokensInformation" rows="3" style="opacity:0"></textarea>
                <v-btn color="#736B63" dark small depressed @click="deleteEnableDisableTokens('','','generate')">
                    generate
                </v-btn>
            </v-toolbar>
            <v-layout wrap class="access-token-sub-navigation">
                <v-flex xs3 md4 class="pl-3">
                    <v-icon color="purple" class="access-token__icons">
                        person
                    </v-icon>
                    <span class="app_token_in_tokens_page">{{userName}}</span>
                </v-flex>
                <v-flex xs4 md4>
                    <v-icon color="purple" class="access-token__icons">
                        vpn_key
                    </v-icon>
                    <span class="app_token_in_tokens_page">{{userToken | tokenMask}}</span>
                </v-flex>
                <v-flex xs3 md3>
                    <v-icon color="purple" class="access-token__icons">
                        brightness_auto
                    </v-icon>
                    <span class="app_token_in_tokens_page">{{apptoken | tokenMask}}</span>
                </v-flex>
                <v-flex xs1 md1 style="text-align:left"> 
                    <v-icon color="purple" v-if="copiedContent" class="access-token__icons">
                        done
                    </v-icon>
                    <v-icon color="purple" v-else @click.stop.prevent="copyAppToken(apptoken, -1)" class="access-token__icons">
                        content_copy
                    </v-icon>
                </v-flex>
            </v-layout>
            <div class="apps_tokens_table_div">
                <table class="apps_component_table">
                    <thead>
                    <tr>
                        <th>Access Token</th>
                        <th>last Used</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(items,index) in tablesTokens" :key="index">
                            <td v-if="items.alias == staredAlias" class="stared-td">
                                <span>
                                    {{staredAlias | tokenMask}}
                                </span>
                            </td>
                            <td v-else class="alignment_for_data">
                                {{items.alias | tokenMask}}
                            </td>
                            <td v-if="items.alias == staredAlias" class="stared-td">
                                -
                            </td>
                            <td v-else class="alignment_for_data">
                                {{items.lastTimeUsed}}
                            </td>
                            <td v-if="items.alias == staredAlias" class="stared-td">
                                <v-layout row wrap>
                                    <v-flex xs4 v-if="index == selectedIndex">
                                        <v-icon class="access-token__icons">
                                            check_circle_outline
                                        </v-icon>
                                    </v-flex>
                                    <v-flex xs4 v-else>
                                        <v-icon @click="copyAppToken(items.alias, index)" class="access-token__icons ml-3">
                                            content_copy
                                        </v-icon>
                                    </v-flex>
                                    <i class="material-icons stars" title="Used internally">star</i>

                                </v-layout>

                            </td>
                            <td v-else class="alignment_for_data actions_allignments">
                                <v-layout row wrap>
                                    <v-flex xs4 v-if="index == selectedIndex">
                                        <v-icon class="access-token__icons">
                                            check_circle_outline
                                        </v-icon>
                                    </v-flex>
                                    <v-flex xs4 v-else>
                                        <v-icon @click="copyAppToken(items.alias, index)" class="access-token__icons ml-3">
                                            content_copy
                                        </v-icon>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-icon @click="deleteEnableDisableTokens(items,index,'delete')" class="access-token__icons">
                                            delete
                                        </v-icon>
                                    </v-flex>
                                    <v-flex xs4 class="toggle-switch">
                                        <v-switch :title="items.enabled ? 'enabled' : 'disabled'" color="blue" class="pa-0 ma-0 mr-1" v-model="items.enabled" @click="deleteEnableDisableTokens(items.enabled,items,'enableDisable')">
                                        </v-switch>
                                    </v-flex>
                                </v-layout>
                            </td>
                        </tr>
                        <tr v-if="genarateToken" id="new_token">
                            <td><input type="text" v-model="storeGenaratedAlias" class="token_genarate_input"/></td>
                            <td>today</td>
                            <td><i class="material-icons check_circle_outline" @click="saveTokensDetails()">check_circle_outline</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </v-card>  
    </div>
</template>
<script>
import Vue from 'vue';
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';

export default {
    name:'tokens',
    props: {
        apptoken: {
            type: String
        },
        userName:{
            type:String
        },
        userToken:{
            type:String
        },
        appid:{
            type:Number
        },
        nodeValue:{
            type: String
        }
    },
    watch: {
        apptoken(){
            var self = this;
            self.tokensApi(self.apptoken);
            // self.get_apptoken();
        }
    },
    data(){
        return{
            genarateToken : false,
            storeGenaratedAlias: '',
            tablesTokens: [],
            staredAlias: '',
            tokensApiFailed: false,
            selectedIndex: -1,
            errorColor: 'error-banner',
            tokensInformation: {},
            copiedContent: false,
            textToCopy:{},
            hide:null
        }
    },
    mounted(){
        var self = this;
        self.tokensApi(self.apptoken);
    },
    filters: {
        tokenMask(token){
            return token.slice(0,8) + "..." + token.slice(-8);
        }
    },
    methods:{
        tokensApi(tokens,index){
            var self = this;
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/access_token/' ,{
                params:{
                    'apptoken' : tokens,
                    'node': self.nodeValue
                }
            }).then((response)=>{
                try{
                    self.getTokens();
                    self.tablesTokens = response.data.accessToken;
                    for(let item in self.tablesTokens){
                        self.tablesTokens[item]['alias'] = self.tablesTokens[item].alias;
                        self.tablesTokens[item]['enabled'] = self.tablesTokens[item].enabled;
                        self.staredAlias = response.data.ui_alias || null;
                        if(self.tablesTokens[item].lastTimeUsed == null){
                            self.tablesTokens[item].lastTimeUsed = 'unused';
                        }else{
                            let usedData  =  new Date(self.tablesTokens[item].lastTimeUsed *1000) .toString();
                            self.tablesTokens[item].lastTimeUsed = usedData.substring(0,usedData.length);
                        }
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.tokensApiFailed = true;
                setTimeout(function(){
                    self.tokensApiFailed  = false;
                },2000);

            });
        },
        
        // method to enable or disable apptoken and to delete apptoken and generate app token 
        deleteEnableDisableTokens(item,data,action){
            var self = this;
            let formData = new FormData();
            switch (action) {
                case 'generate':
                    self.genarateToken = true;
                    formData.append('json', JSON.stringify({'apptoken': self.apptoken,
                        'action': 'add',
                        'node':self.nodeValue
                    }));
                    break;
                case 'delete':
                    formData.append('json', JSON.stringify({'apptoken': self.apptoken,
                        'action':'delete',
                        'accesstoken': item.alias,
                        'node':self.nodeValue
                    }));
                    break;
                default:
                    formData.append('json',JSON.stringify({'apptoken':self.apptoken,
                        'action': item ? 'enable' : 'disable',
                        'accesstoken': data.alias,
                        'node':self.nodeValue
                    }));
            }
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/access_token/',formData)
            .then((res) =>{
                try{
                    if(action == 'generate'){
                        var genarate_alias = res.data;
                        self.storeGenaratedAlias = genarate_alias.alias.slice(0,8) + "..." + genarate_alias.alias.slice(-8) ;
                        setTimeout(function(){
                            document.getElementById('new_token').scrollIntoView();
                        },1);
                    } else{
                        self.tokensApi(self.apptoken);
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.tokensApiFailed = true;
                setTimeout(function(){
                    self.tokensApiFailed  = false;
                },2000);

            });
        },
        saveTokensDetails(){
           this.tokensApi(this.apptoken);
           this.genarateToken = false;
        },
        
        getTokens(){
            var self = this;
            let textToCopy = {};
            // We shouldn't do this -- SM
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/get_tokens/', {
                params:{
                    'app_id' :self.appid
                }
            })
            .then((res)=>{
                try{
                    let tokens_data = res.data;
                    self.textToCopy = {
                        'x-username':  res.data.username,
                        'x-token': res.data.usertoken,
                        'x-apptoken': res.data.apptoken
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                console.log("error");
            })
        },
        copyAppToken(token,index){
            var self = this, codeToCopy = '';
            self.tokensInformation = {},
            self.tokensInformation = {
                'x-username':  self.textToCopy['x-username'],
                'x-token': self.textToCopy['x-token'],
                'x-apptoken': index >= 0 ? token : self.textToCopy['x-apptoken'],
            }
            codeToCopy = document.querySelector('#unmasked_token_data');
            codeToCopy.value = JSON.stringify(self.tokensInformation).replace(/,/g, '\n').replace(/"/g,'').replace(/[{}]/g,'').split(':').join(' : ');
            codeToCopy.select();
            try {
                document.execCommand('copy');
                if(index >= 0){
                    self.selectedIndex = index;
                }else{
                    self.copiedContent = true;
                }
                setTimeout(function(){
                    self.enable_copy_apptoken_icon = false;
                    self.copiedContent = false;
                    self.selectedIndex = -1;
                },1000);
            } catch (err) {
                alert('Oops, unable to copy');
            }
        },
        showLoadIcon,
        hideLoadIcon
    }
}
</script>
<style scoped lang="scss">
.access-token__icons {
    font-size: 1rem;
}
.snackbar-button {
    box-shadow: none ;
}
</style>